import type { TInvitationSortField } from '../types/TInvitationSortField';

type TSortableInvitation = {
  createdAt: string;
  email: string;
};

const compareInvitations = (field: TInvitationSortField, left: TSortableInvitation, right: TSortableInvitation) =>
  field === 'createdAt'
    ? new Date(left.createdAt).getTime() - new Date(right.createdAt).getTime()
    : left.email.localeCompare(right.email, undefined, { sensitivity: 'base' });

export const sortInvitations = <T extends TSortableInvitation>(
  invitations: T[],
  field: TInvitationSortField,
  reverse: boolean,
) =>
  [...invitations].sort((left, right) =>
    reverse ? compareInvitations(field, right, left) : compareInvitations(field, left, right),
  );
